module.exports = __webpack_public_path__ + "img/kf.30d2ccca.png";